import React, { useState, useEffect, useContext } from "react";
import "./Cart.css";
import {
  data,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { postData, serverURL } from "../../services/NodeServices";
import AddressComp from "./AddressComp/AddressComp";
import { MyContext } from "../../context/MyContext";
import AddAddress from "./AddAddressForm/AddAddress";
import { toast } from "react-toastify";
import EditAddress from "./EditAddress/EditAddress";
import ProductList from "./ProductsCart";
import BillComponent from "./BillRender";
import AddressCompTailwind from "./AddressComp/AddressCompTailwind";

export default function Cart
() {
  const navigate = useNavigate();
  const { cart, setCart, user, isloggedIn } = useContext(MyContext);
  const [coins, setCoins] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [coinInput, setCoinInput] = useState("");

  const [appliedCoins, setAppliedCoins] = useState(0);

  const [myaddress, setMyaddress] = useState("");
  const [bill, setBill] = useState(false);
  const [loading, setLoading] = useState(true);
  const [couponText, setCouponText] = useState("");
  const [coupon, setCoupon] = useState(false);

  const loadRazorpayScript = () => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () =>
        reject(new Error("Failed to load Razorpay script"));
      document.body.appendChild(script);
    });
  };

  const getEstimatedDelivery = async () => {

   let cartt =  JSON.parse(localStorage.getItem("cart") || "[]")


    let body = {
      pincode: myaddress.zipcode || "474001",
      weight: cartt.reduce((total, item) => {
        return total + 255 * item.quantity;
      }, 0)/1000,
      amount: cartt.reduce((total, item) => {
        return total + item.variant.current_price * item.quantity;
      }, 0),
    };

    console.log("body we sending is for edimated ", body);

    try {
      const result = await postData("api/order/get-estimated-rate", body);

      if (result.status) {
        // Handle successful response

        return result?.rate;
      }
    } catch (error) {
      console.error("Error fetching estimated delivery rate:", error);
      return 5;
    }
  };

 /*  useEffect(() => {
    getEstimatedDelivery().then((rate) => {
      setBill((prevBill) => ({
        ...prevBill,
        shipping: rate,
      }));
    });
  }, []); */

  const getCoins = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      console.log("are we seidn userid", user.userid);

      const result = await postData("api/users/getwallet", {
        userid: user.userid,
      });

      if (result.status) {
        setCoins(result.data.coins);
      }
    } catch {}
  };

  useEffect(() => {
    getCoins();
  }, []);

  const handleSubmit = async () => {
    /*   if(!validate()){
      return
    } */

    console.log("address we seidning is ", myaddress);

    loadRazorpayScript();

    const response = await fetch(`${serverURL}create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: bill.finalPrice }),
    });

    const order = await response.json();

    const options = {
      /*   key: "rzp_live_ihXhp7al0XuYsU", */
      key: "rzp_test_nt89OO93hs7lOa",
      amount: order.amount,
      currency: order.currency,
      name: "Products",
      description: "Payment for buying shirt",
      order_id: order.id,
      handler: async (paymentResponse) => {
        console.log(paymentResponse);

        const verifyResponse = await fetch(`${serverURL}verify-payment`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            payment_id: paymentResponse.razorpay_payment_id,
            order_id: paymentResponse.razorpay_order_id,
            signature: paymentResponse.razorpay_signature,
            data: {
              list: cart,
              bill: bill,
              address: myaddress,
              coins: appliedCoins,
            },
          }),
        });

        const verificationResult = await verifyResponse.json();
        console.log(verificationResult);

        if (verificationResult.status) {
          setCart([]);

          setTimeout(() => {
            navigate("/");
          }, 511);
        } else {
        }
      },
      prefill: {
        name: "User Name",
        email: "user@example.com",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const razorpay = new window.Razorpay(options);
    razorpay.open();
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    // Allow only numbers and prevent input greater than available coins
    if (/^\d*$/.test(value) && Number(value) <= coins) {
      setCoinInput(value);
    }
  };

  useEffect(() => {
    generateBill();
  }, []);
  const [mycart, setMyCart] = useState(cart);

  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  const [topProducts, setTopProducts] = useState(
    JSON.parse(localStorage.getItem("cart") || "[]")
  );
  const [page, setPage] = useState(1);

  const handleRemove = (variant_id) => {
    // Filter out the item to remove from the cart
    const updatedCart = topProducts.filter(
      (item) => item.variant.variant_id !== variant_id
    );
    setCart(updatedCart); // Update the context cart state
    setTopProducts(updatedCart); // Update the local state as well
    generateBill();
  };
  useEffect(() => {
    generateBill();
  }, [cart]);
  const generateBill = async() => {
    let totalPrice = 0;
    let shippingPrice = await getEstimatedDelivery() ||75; // Example shipping price, you can adjust this as needed

    // Map each product to the required bill structure
    const billItems = topProducts.map((item) => {
      const productDetail = `${truncateText(
        item.variant.variantname,
        61
      )}, Size: ${item.variant.size}`;
      const productPrice = item.variant.current_price * item.quantity; // Assuming price is per unit and quantity is specified

      totalPrice += productPrice;

      return {
        product: productDetail,
        size: item.variant.size,
        color: item.variant.color,
        price: productPrice,
      };
    });
   
    let gst = parseInt((totalPrice * 18) / 100);
    let discount = coupon
      ? Math.min(parseInt((totalPrice * coupon.value) / 100), coupon.maxval)
      : 0;
    // Create the final structure with 'items', shipping, and final price

    let shipping = shippingPrice;
    const bill = {
      items: billItems,
      shipping: shipping,
      discount: parseInt(discount) + parseInt(coinInput),
      gst: gst,
      finalPrice:
        totalPrice +
        parseInt(shippingPrice) -
        parseInt(discount) -
        coinInput +
        gst,
    };

    setBill(bill); // Update the state with the new bill structure
  };

  const generateBillNoCoin = async() => {
    let totalPrice = 0;
    let shippingPrice = await getEstimatedDelivery() ; // Example shipping price, you can adjust this as needed

    // Map each product to the required bill structure
    const billItems = topProducts.map((item) => {
      const productDetail = `${truncateText(
        item.variant.variantname,
        61
      )}, Size: ${item.variant.size}`;
      const productPrice = item.variant.current_price * item.quantity; // Assuming price is per unit and quantity is specified

      totalPrice += productPrice;

      return {
        product: productDetail,
        size: item.variant.size,
        color: item.variant.color,
        price: productPrice,
      };
    });

    let gst = parseInt((totalPrice * 18) / 100);
    if (totalPrice > 500) {
      shippingPrice = 0;
    }

    let discount = coupon
      ? Math.min(parseInt((totalPrice * coupon.value) / 100), coupon.maxval)
      : 0;
    // Create the final structure with 'items', shipping, and final price
    const bill = {
      items: billItems,
      shipping: shippingPrice,
      discount: discount,
      gst: gst,
      finalPrice: totalPrice + parseInt(shippingPrice) - parseInt(discount),
    };

    setBill(bill); // Update the state with the new bill structure
  };
  const location = useLocation();

  const handleContinue = () => {
    if (location.pathname == "/cart" && isloggedIn) {
      navigate("/cart/select-address");
    } else if (location.pathname == "/cart/select-address" && myaddress) {
      handleSubmit();
    }
    console.log(bill);
  };

  const validateCoupon = async () => {
    console.log("coupon code we sending is ", couponText);
    try {
      const result = await postData("api/coupons/validate", {
        couponname: couponText,
      });
      console.log(result);
      if (result.status) {
        if (result.coupon) {
          toast.success("coupon code has been added");
          setAppliedCoins(0);
          setCoinInput(0);
          setCoupon(result.coupon);
        } else {
          toast.error("coupon code is invalid");
        }
      }
    } catch {}
  };

  useEffect(() => {
    if (coupon !== null) {
      generateBill();
    }
  }, [coupon]);

  const applyCoins = () => {
    console.log("we getting applied coin as ", coinInput);

    if (coinInput > 0 && coinInput <= coins && coinInput < bill.finalPrice) {
      console.log("we setting applied coin as ", coinInput);

      setAppliedCoins(coinInput);

      setShowInput(false);

      generateBill();
    } else {
      alert("Invalid coin amount!");
    }
  };

  const handleCoinCancel = () => {
    setAppliedCoins("");
    setCoinInput("");
    setShowInput(false);
    generateBillNoCoin();
  };


  const cancelCoupon = () => {
    setCoupon(false);
    setCouponText("");
  };

  return (
    <div className="cart__cont min-h-screen max-xs:!px-2 max-xs:!gap-0">
      <div className="cart__inner mt-20">
        <div className="cart__left">
          <Routes>
            <Route path="/add-address" element={<AddAddress />} />
            <Route path="/edit-address/:id" element={<EditAddress />} />
            <Route path="/" element={<ProductList topProducts={topProducts} handleRemove={handleRemove} setTopProducts={setTopProducts} generateBill={generateBill} cart={cart} setCart={setCart} />} />
            <Route
              path="/select-address"
              element={
                <AddressCompTailwind address={myaddress} setAddress={setMyaddress} />
              }
            />
          </Routes>
        </div>
        {topProducts && topProducts.length != 0 ? (
          <div className="cart__right p-0" >
            <BillComponent 
              topProducts={topProducts}
  bill={bill}
  coins={coins}
  coupon={coupon}
  couponText={couponText} 
  setCouponText={setCouponText}
  validateCoupon={validateCoupon}
  cancelCoupon={cancelCoupon}
  appliedCoins={appliedCoins}
  setAppliedCoins={setAppliedCoins}
  coinInput={coinInput}
  setCoinInput={setCoinInput}
  handleInputChange={handleInputChange}
  applyCoins={appliedCoins}
  handleCoinCancel={handleCoinCancel}
  isloggedIn={isloggedIn}
  handleContinue={handleContinue}
  navigate={navigate}
            
            
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
